import { jsx as e } from "react/jsx-runtime";
import { NeuFeedback as n } from "@hcahealthcaredpx/neutron-react";
const i = ({ isVisible: r }) => r ? /* @__PURE__ */ e("div", { className: "neu-modal neu-modal-backdrop neu-level-1 state-active", children: /* @__PURE__ */ e(n, { kind: "spinner" }) }) : null;
export {
  i as L
};
